import { FC } from 'react';

import { BottomSheet } from '../../../BottomSheet';
import { Modal, ModalHeaderProps } from '../../../Modal';
import { useMedia } from '../../../useMedia';
import { DIALOG_DESKTOP_QUERY } from '../query';

export type ResponsiveDialogHeaderProps = ModalHeaderProps;

/** Modal.Header на десктопе, BottomSheet.Header на мобайле. */
const ResponsiveDialogHeader: FC<ResponsiveDialogHeaderProps> = (props) => {
  const isDesktop = useMedia(DIALOG_DESKTOP_QUERY);

  return isDesktop ? <Modal.Header {...props} /> : <BottomSheet.Header {...props} />;
};

export default ResponsiveDialogHeader;
